import React from 'react';

import Image from 'ui-components/Image';
import ProductPrice from 'components/ProductPrice';
import { Addon } from 'components/Addons/interface';
import { RootStyled, CardHeaderStyled, TypographyStyled } from './styled';

const AddonItem = ({
  name,
  price,
  sales_price: salesPrice,
  cloudinary_id: image,
  quantity,
}: Addon) => (
  <RootStyled>
    <Image useWebP src={image} alt={name} width="100%" isSquare />
    <CardHeaderStyled variant="body1" noWrap>
      {name}
    </CardHeaderStyled>
    <TypographyStyled variant="body1" noWrap>
      Price: <ProductPrice price={price} salesPrice={salesPrice} />
    </TypographyStyled>
    <TypographyStyled variant="body1">Qty: {quantity}</TypographyStyled>
  </RootStyled>
);

export default AddonItem;
